import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";

const TEXT = {
  it: {
    msg: "Questo sito utilizza cookie tecnici e, previo tuo consenso, strumenti di analisi aggregata per migliorare l'esperienza. Dettagli nella",
    link: "Cookie Policy",
    accept: "Accetta",
    reject: "Rifiuta",
  },
  en: {
    msg: "This site uses technical cookies and, with your consent, aggregated analytics tools to improve the experience. Details in the",
    link: "Cookie Policy",
    accept: "Accept",
    reject: "Reject",
  },
};

export const CookieBanner = () => {
  const { lang } = useLanguage();
  const t = TEXT[lang] || TEXT.it;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("rvfilm-cookie-consent")) setVisible(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem("rvfilm-cookie-consent", value);
    try {
      if (window.posthog) {
        if (value === "accepted") window.posthog.opt_in_capturing();
        else window.posthog.opt_out_capturing();
      }
    } catch {
      /* posthog not loaded */
    }
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-0 left-0 right-0 sm:bottom-4 sm:left-4 sm:right-auto sm:max-w-md z-[99] bg-[#16181D]/95 backdrop-blur-xl border border-white/10 rounded-t-xl sm:rounded-lg p-6 shadow-2xl"
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Cookie consent"
        >
          <p className="text-sm text-slate-300 leading-relaxed">
            {t.msg}{" "}
            <Link to="/cookie-policy" className="text-red-500 hover:text-red-400 transition-colors underline underline-offset-2">
              {t.link}
            </Link>
            .
          </p>
          <div className="mt-5 flex gap-3">
            <button
              onClick={() => choose("accepted")}
              data-testid="cookie-accept-button"
              className="flex-1 bg-red-600 hover:bg-red-500 transition-colors text-white f-mono text-[11px] uppercase tracking-[0.15em] px-4 py-3 rounded-full"
            >
              {t.accept}
            </button>
            <button
              onClick={() => choose("rejected")}
              data-testid="cookie-reject-button"
              className="flex-1 border border-white/15 hover:border-white/40 transition-colors text-slate-300 f-mono text-[11px] uppercase tracking-[0.15em] px-4 py-3 rounded-full"
            >
              {t.reject}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
